import { environment } from 'src/environments/environment';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { NavigationService } from 'src/app/shared/services/navigation.service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from 'src/app/shared/models/constants/modal.config';
import { CompanyService } from 'src/app/modules/services/license/company/services/company.service';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { LookupBase } from 'src/app/shared/models/lookup.base.model';
import { APP_ROUTER } from '../../../shared/models/app.route';
import { CacheService } from 'src/app/shared/services/cashe-service';
import { HomePageStaticsDto } from 'src/app/modules/services/license/company/models/HomePageStaticsDto';
import { Chart } from 'chart.js';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IgxItemLegendComponent, IgxPieChartComponent } from 'igniteui-angular-charts';
import { EnergyGlobalDemand } from 'src/app/modules/services/license/notification-log/models/EnergyGlobalDemandItem';


@Component({
  selector: 'app-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.css']
})
export class PortalHomeComponent extends BaseComponent implements OnInit {

  searchText: string;
  companies: string = APP_ROUTER.Companies;
  modalRef: BsModalRef;
  isCompanyLogin:any;
  digitalAuthentication: string = APP_ROUTER.DigitalAuthentication;
  digitalProduct: string = APP_ROUTER.DigitalProduct;
  @ViewChild('ChooseCompanyModal') ChooseCompanyModal: TemplateRef<any>;
  modalConfig = {
    class: ModalConfig.class_xlg,
    backdrop: true,
    
  };

  constructor(public override router: Router,
    private modalService: BsModalService,
    private _companyprofileService: CompanyService,
    private _detector: ChangeDetectorRef,
    private navigate: NavigationService) {
    super();
    this.searchText = "";

  }
  @ViewChild("legend", { static: true } )
  private legend: IgxItemLegendComponent
  @ViewChild("chart", { static: true } )
  private chart: IgxPieChartComponent
  private _energyGlobalDemand: EnergyGlobalDemand = null;
  public get energyGlobalDemand(): EnergyGlobalDemand {
    debugger;
      if (this._energyGlobalDemand == null)
      {
          this._energyGlobalDemand = new EnergyGlobalDemand();
      }
      return this._energyGlobalDemand;
  }

 
  ngOnInit(): void {

    //Home Page
    // this.isCompanyLogin= JSON.parse( localStorage.getItem("isCompanyLogin"));
    // if(this.isCompanyLogin == null || this.isCompanyLogin == undefined){
    //   this.isCompanyLogin = true;
    // }
    this.GetHomePAgeStatics();



  }



  homePageStatics:HomePageStaticsDto;
  GetHomePAgeStatics(){
    this._companyprofileService
          .GetHomePageStatics()
          .subscribe((data: ApiResponse<HomePageStaticsDto>) => {
            this.homePageStatics = data.value;
            debugger;
          });
  }
  myUrl: string = '';
  myCompanyId: string = '';
  search(searchText: string) {
    var list = document.getElementsByClassName("e-service-card__title");
    for (var i = 0; i < list.length; i++) {
      if (!list[i].innerHTML.toLowerCase().includes(searchText.trim().toLowerCase())) {
        list[i].parentElement.parentElement.parentElement.classList.add("d-none");
      }
      else {
        list[i].parentElement.parentElement.parentElement.classList.remove("d-none");
      }
    }
  };

  MyCompanies: LookupBase[];
  AllowToAddRequest: boolean = true;
  GetApprovedCompanies(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.MyCompanies == null || this.MyCompanies.length <= 0) {
        this._companyprofileService.GetApprovedCompanies().subscribe((data: ApiResponse<LookupBase[]>) => {
          this.MyCompanies = data.value;
          resolve();
        });
      }else{
        resolve();
      }
    });
  }
  
  ShowCompanies(url) {
    if (this.MyCompanies==null ||this.MyCompanies.length <= 0) {
      this.AllowToAddRequest = false;
      this.modalRef = this.modalService.show(this.ChooseCompanyModal, this.modalConfig);
    } else {
      this.AllowToAddRequest = true;
      if (this.MyCompanies.length == 1) {
        this.router.navigate([url + this.MyCompanies[0].id+ "/1"]);
      }
      else{
        this.modalRef = this.modalService.show(this.ChooseCompanyModal, this.modalConfig);
      }
    }
  }

  openChooseCompanyModal(url) {
    this.myUrl = url;
    this.GetApprovedCompanies().then(() => this.ShowCompanies(url));
  }
  RedirectToAdd(id) {
    this.modalService.hide();
    this.router.navigate([this.myUrl + id+"/1"]);

  }


}
